import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
} from "reactstrap";
import { fetchAvailableTemplates } from "../helpers/UserTemplateHelpers";

export default function ChooseTemplateModal({ isOpen, onClose, onApply }) {
    const [templates, setTemplates] = useState({ tWBTemplates: [], myTemplates: [], accountTemplates: [] });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        setLoading(true);
        fetchAvailableTemplates().then(result => {
            setTemplates(result || { tWBTemplates: [], myTemplates: [], accountTemplates: [] });
            setLoading(false);
        });
    }, [isOpen]);

    const renderTemplateGroup = (label, group) => {
        if (!group || group.length === 0) {
            return null;
        }
        return (
            <div className="mb-3">
                <h3 className="text-primary text-uppercase" style={{fontSize: "0.75rem"}}>{label}</h3>
                <div className="service-plan-template-grid">
                    {group.map(template => (
                        <Button
                            key={template.id}
                            className="service-plan-template-button"
                            color={(template.items || []).length === 0 ? "secondary" : "primary"}
                            type="button"
                            onClick={() => onApply(template)}
                        >
                            <strong>{template.name}</strong>
                            <br />
                            <span>{(template.items || []).length} sections</span>
                        </Button>
                    ))}
                </div>
            </div>
        );
    };

    const hasTemplates = (templates.accountTemplates || []).length > 0 ||
        (templates.myTemplates || []).length > 0 ||
        (templates.tWBTemplates || []).length > 0;

    return (
        <Modal className="modal-dialog-centered" size="lg" isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>Start from a template?</ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner />
                    </div>
                ) : hasTemplates ? (
                    <>
                        {renderTemplateGroup("Account Templates", templates.accountTemplates)}
                        {renderTemplateGroup("My Templates", templates.myTemplates)}
                        {renderTemplateGroup("TWB Templates", templates.tWBTemplates)}
                    </>
                ) : (
                    <p className="description">No templates yet. <a href="/my/templates">Create one</a></p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" type="button" onClick={onClose}>
                    Start blank
                </Button>
            </ModalFooter>
        </Modal>
    );
}
